<template>
  <div v-if="calloutType && refundableDays > 0" class="guarantee-container">
    <GuaranteeText
      :callout-type="calloutType"
      :refundable-days="refundableDays"
      :is-freebie="isFreebie"
      :interval="interval"
    />
  </div>
</template>

<script>
import GuaranteeText from './GuaranteeText.vue';

export default {
  components: {
    GuaranteeText,
  },
  props: {
    calloutType: {
      type: String,
      required: true,
    },
    refundableDays: {
      type: Number,
      required: true,
    },
    isFreebie: {
      type: Boolean,
      required: true,
    },
    interval: {
      type: Number,
      required: false,
      default: null,
    },
  },
};
</script>

<style scoped>

  .guarantee-container {
    background: #f5f5f9;
    display: flex;
    align-items: center;
    padding: 16px;
    margin-top: 20px;
  }

  @media (min-width: 992px) {
    .guarantee-container {
      margin-top: 0;
      padding: 24px 16px;
      justify-content: center;
    }
  }
</style>
